/*
  Tabbed collections.

  Every tab but the first ships inside a template element: parsed, but not
  part of the document, so the browser does no style or layout work for it.
  On a homepage with four of these sections and two tabs each, that is half
  the product cards on the page kept inert until somebody asks for them.

  The tabs themselves are radio inputs and CSS. This script only fills a
  panel the first time its tab is chosen, so with no JavaScript the first
  tab still works and the others are simply empty rather than broken.
*/
if (!customElements.get('tabbed-collections')) {
  class TabbedCollections extends HTMLElement {
    connectedCallback() {
      /*
        change fires on the radio that becomes checked, and radios in a group
        do not fire when they lose it, so one listener on the container is
        enough to know which panel is now showing.
      */
      this.addEventListener('change', this.onChange.bind(this));

      /*
        A tab can already be selected when this runs: the browser restores
        radio state on a back navigation, and it happens before the element
        upgrades. Without this the restored tab would be blank.
      */
      const checked = this.querySelector('.tabbed-collections__radio:checked');
      if (checked) this.hydrate(checked);
    }

    onChange(event) {
      const radio = event.target.closest('.tabbed-collections__radio');
      if (radio) this.hydrate(radio);
    }

    /*
      Cloning rather than fetching. The markup is already here, so switching
      tabs is instant; a request would put a wait in front of a grid the
      shopper has just asked to see, which is the one place a wait is most
      obvious.

      Once swapped in the template is gone, so this does nothing on every
      subsequent switch.
    */
    hydrate(radio) {
      const index = radio.dataset.tcIndex;
      if (!index) return;

      const panel = this.querySelector(`[data-tc-panel="${index}"]`);
      if (!panel) return;

      const template = panel.querySelector('[data-tc-template]');
      if (!template) return;

      template.replaceWith(template.content.cloneNode(true));

      /*
        slider-component and scroll-progress are custom elements and upgrade
        themselves as soon as they are in the document, so nothing needs to
        be initialised here.
      */
    }
  }

  customElements.define('tabbed-collections', TabbedCollections);
}
